@if (platformModeService.isNativeApp()) {
  <ion-app>
    <ion-router-outlet></ion-router-outlet>
  </ion-app>
} @else {
  <div class="bw-browser-app">
    <router-outlet></router-outlet>
  </div>
}
